import { Card, Grid, Heading, Image, Stack, Text } from "@chakra-ui/react";
import React from "react";
import { BsArrowRight } from "react-icons/bs";
import { FilledButton, GreenFilledButton, OutlineButton } from "./Button";
import AppointButton from "./AppointButton";
import CustomCard from "./CustomCard";

const services = [
  {
    src: "../assets/itr.png",
    title: "Income Tax Filing",
    description:
      "File your Income Tax Returns with confidence. Our tax professionals ensure accuracy, maximize deductions, and keep you compliant – quickly and effortlessly.",
    serviceText: "File Your ITR Now",
  },
  {
    src: "../assets/gst.png",
    title: "GST  & Business Registration",
    description:
      "From managing GST returns to registering your business, we simplify the complexities of compliance, ensuring peace of mind so you can focus on growth.",
    serviceText: "Get GST Assistance",
  },
];

const ServicesGrid = () => {
  return (
    <>
      <Grid
        templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }}
        px={{ base: "5", md: "10", lg: "44" }}
        gap={{ base: "10", md: "20", lg: "10" }}
        mb={10}
        justifyItems="center"
      >
        {services.map(({ src, title, description }) => (
          <CustomCard
            data-aos="flip-right"
            button1="Book a Call"
            button2="Whatsapp Us"
            title={title}
            description={description}
            src={src}
            url2="https://wa.me/+919757476672"
          />
        ))}
      </Grid>
    </>
  );
};

export default ServicesGrid;
